import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { PermissionGuard } from "~/modules/Auth/PermissionGuard";
import { dashboardPermissionRequirements } from "~/modules/Dashboard/dashboardPermissionRequirements";
import TeamArea from "./TeamArea";

const TeamRouter = (): React.ReactElement => {
  return (
    <Routes>
      <Route
        index
        element={
          <PermissionGuard requirement={dashboardPermissionRequirements.teamArea}>
            <TeamArea />
          </PermissionGuard>
        }
      />
      {/* Stare bezpośrednie trasy — zakładki i linki sprzed przejścia na taby. */}
      <Route path="/stats" element={<Navigate to="/team?tab=stats" replace />} />
      <Route path="/chat-metrics" element={<Navigate to="/team?tab=chat-metrics" replace />} />
    </Routes>
  );
};

export default TeamRouter;
